import { Component, Input, OnChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DateTime } from 'luxon';
import { IInfoLabels } from 'modules/video-conference/interfaces/infolabels.interface';
import { MaskPipe } from 'ngx-mask';
import { IContact } from 'shared/interfaces/contact.interface';

@Component({
	selector: 'contact-info',
	templateUrl: './contact-info.component.html',
	styleUrls: ['./contact-info.component.scss'],
	providers: [MaskPipe],
})
export class ContactInfo implements OnChanges {
	labels: IInfoLabels = <IInfoLabels>{};

	constructor(
		private maskPipe: MaskPipe,
		private translateService: TranslateService
	) {}

	@Input() contactData: IContact;

	ngOnChanges(): void {
		if (this.contactData) {
			this.labels.age = this.getLabelAge(this.contactData.birthdate);
			this.labels.livesAt = this.getLabelHome(this.contactData);
			this.labels.fiscalId = this.getLabelFiscalId(this.contactData);
			this.setLabelGender(this.contactData.gender);
		}
	}

	getLabelAge(birthdate: string): string {
		if (!birthdate) {
			return '';
		}

		const noSlashBirthdate = birthdate.replace(/(\/)/g, '-');
		const datePT = DateTime.fromFormat(noSlashBirthdate, 'dd-MM-yyyy');
		const dateEN = DateTime.fromFormat(noSlashBirthdate, 'yyyy-MM-dd');

		const { years: contactAge } = DateTime.now()
			.diff(datePT['invalid'] ? dateEN : datePT, 'years')
			.toObject();

		return `${Math.floor(contactAge)} ${this.translateService.instant(
			'SESSION.USERINFO.YEARS'
		)},`;
	}

	getLabelHome(contactData: IContact): string {
		const { city, state } = contactData;
		const label = this.translateService.instant('SESSION.USERINFO.LIVES_AT');

		if (city && state) {
			return `${label} ${city} - ${state},`;
		}

		if (city) {
			return `${label} ${city},`;
		}

		if (state) {
			return `${label} ${state},`;
		}

		return '';
	}

	getLabelFiscalId(contactData: IContact): string {
		if (contactData.fiscalId) {
			const label = this.translateService.instant('SESSION.USERINFO.FISCAL_ID');
			const maskedFiscalId = this.maskPipe.transform(
				contactData.fiscalId,
				'000.000.000-00'
			);

			return `${label} ${maskedFiscalId}`;
		}

		return '';
	}

	setLabelGender(genderValue: string): void {
		const genderOptionsPath = 'MY_ACCOUNT.PERSONAL.GENDER_OPTIONS';

		this.translateService
			.get([genderOptionsPath])
			.subscribe(({ [genderOptionsPath]: optionsObj }) => {
				for (const property in optionsObj) {
					const option = optionsObj[property];
					if (option.value === genderValue) {
						this.labels.gender = option.label + ',';
					}
				}
			});
	}
}
